import {
  AxiomaW1,
  AxiomaW1Alarm,
  AxiomaW1AlarmQuery,
  AxiomaW1Telemetry,
  AxiomaW1TelemetryQuery,
  AxiomaW1Volume,
  AxiomaW1VolumeQuery
} from '../types'
import { AxiosRequestConfig } from 'axios'
import { useApi } from '../hooks'
import * as stubs from './axioma.stub'

const api = useApi('v2')

const USE_STUBS = false

export async function getAxiomW1s(config?: AxiosRequestConfig) {
  if (USE_STUBS) {
    return stubs.getAxiomW1s(config)
  }

  const response = await api.get<AxiomaW1[]>('axioma/w1', config)

  return response.data
}

export async function getAxiomaW1(id: string, config?: AxiosRequestConfig) {
  if (USE_STUBS) {
    return stubs.getAxiomaW1(id, config)
  }

  const response = await api.get<AxiomaW1>(`axioma/w1/${id}`, config)

  return response.data
}

export async function getAxiomaW1Telemetries(
  id: string,
  query: AxiomaW1TelemetryQuery,
  config?: AxiosRequestConfig
) {
  if (USE_STUBS) {
    return stubs.getAxiomaW1Telemetries(id, query, config)
  }

  const response = await api.get<AxiomaW1Telemetry[]>(`axioma/w1/${id}/telemetries`, {
    ...config,
    params: query
  })

  return response.data
}

export async function getAxiomaW1Telemetry(id: string, config?: AxiosRequestConfig) {
  if (USE_STUBS) {
    return stubs.getAxiomaW1Telemetry(id, config)
  }

  const response = await api.get<AxiomaW1Telemetry>(`axioma/w1/${id}/telemetries/latest`, config)

  return response.data
}

export async function getAxiomaW1Volumes(
  id: string,
  query: AxiomaW1VolumeQuery,
  config?: AxiosRequestConfig
) {
  if (USE_STUBS) {
    return stubs.getAxiomaW1Volumes(id, query, config)
  }

  const response = await api.get<AxiomaW1Volume[]>(`axioma/w1/${id}/volumes`, {
    ...config,
    params: query
  })

  return response.data
}

export async function getAxiomaW1Alarms(
  id: string,
  query: AxiomaW1AlarmQuery,
  config?: AxiosRequestConfig
): Promise<AxiomaW1Alarm[]> {
  if (USE_STUBS) {
    return stubs.getAxiomaW1Alarms(id, query, config)
  }

  const response = await api.get<AxiomaW1Alarm[]>(`axioma/w1/${id}/alarms`, {
    ...config,
    params: query
  })

  return response.data
}

export async function getAxiomaW1ActiveAlarms(
  id: string,
  config?: AxiosRequestConfig
): Promise<AxiomaW1Alarm[]> {
  if (USE_STUBS) {
    return stubs.getAxiomaW1ActiveAlarms(id, config)
  }

  const response = await api.get<AxiomaW1Alarm[]>(`axioma/w1/${id}/alarms/active`, config)

  return response.data
}
